<div
    class="anc-radio-group"
    role="radiogroup"
    [class.anc-radio-group--horizontal]="orientation() === 'horizontal' || variant() === 'segmented'"
    [class.anc-radio-group--segmented]="variant() === 'segmented'"
    [class.anc-radio-group--disabled]="disabled()"
>
    <ng-content></ng-content>
</div>
